import React from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
  height: 60px;
  width: 23.5px;

  @media (max-width: 959px) {
    display: none;
  }
`

const Divider = () => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 37.915 97.001"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_15"
            data-name="Rectangle 15"
            width="37.915"
            height="97.001"
            transform="translate(0 0)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Group_83" data-name="Group 83" transform="translate(0 0)">
        <g
          id="Group_10"
          data-name="Group 10"
          transform="translate(0 0)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_5"
            data-name="Path 5"
            d="M37.915,96.974,34.8,97c-.243-1.2-1.284-1.765-2.041-2.53Q21.279,82.876,9.75,71.327a32.472,32.472,0,0,1-.033-46.364Q21,13.6,32.176,2.137c.6-.609,1.557-1.028,1.459-2.137l3.2.183c-.722.832-1.4,1.709-2.171,2.488Q23.14,14.265,11.588,25.83c-13.06,13.1-13,31.539.112,44.72Q24.827,83.743,37.915,96.974"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </IconWrapper>
)

export default Divider
